import type { DocumentSection } from "@/lib/types"

// True for the last readable section of a preview group: the first section,
// when the document is a preview and later sections in the group are placeholders.
export function hasCutoff(preview: boolean | undefined, sections: DocumentSection[], index: number) {
  return !!preview && index === 0 && sections.slice(1).some((s) => s.preview_placeholder)
}
